import { render } from "./overlay.vue?vue&type=template&id=2701f291"
import script from "./overlay.vue?vue&type=script&lang=js"
export * from "./overlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__